import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_36: FaireProductEntity = {
  token: "legacy_prod_abbott-36",
  type: "product",
  name: 'All Purpose Scissors Orange 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c3b12a8fc6d6702b6b757f5bb58d2a8cb451b2d5732066498c513bcdca42f347.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
